"use client";

import { useState, useEffect } from 'react';
import style from './loader.module.scss';
import cn from "classnames/bind";
export const Loader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);
    return () => {
      clearTimeout(timeout);
    };
  }, [show]);
  return <>
            {process.env.NODE_ENV === 'production' && <div className={cn(style.loader_wrapper, {
      [style.loderhide]: !show
    })} style={{
      zIndex: '99999999999999999'
    }}>
                    <div className={cn(style.loader_index)}><span /></div>
                    <svg>
                        <defs />
                        <filter id="goo">
                            <fegaussianblur in="SourceGraphic" stdDeviation="11" result="blur" />
                            <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
                        </filter>
                    </svg>
                </div>}
        </>;
};